/**
 * @enum {enumViewType} The type of view to be presented in UIs that offer view choices.
 */
// NOTE: This enum is in the 'dataObjects' library (instead of the UI library) since a user's view choices will
//       be captured in state (redux store) and we don't want the redux logic to be dependent on the UI library.
export enum enumViewType {
  ListView = 'ListView', // display data in the form of a list
  CardsGridView = 'CardsGridView', // display data in the form of cards displayed within a 2-dimensional grid
}
